import QrcodeVue from 'qrcode.vue';
import {XDev} from 'x.vue.components.dev';
import './qr.css';

export const Qr = {
    components: {
        QrCode: QrcodeVue,
        XDev: XDev
    },
    props: {
        valid: {
            type: Boolean,
            default: true,
        },
        value: {
            type: String,
            required: true,
        },
        logoUrl: {
            type: String,
            default: '',
        },
        size: {
            type: Number,
            default: 320,
        },
        level: {
            type: String,
            default: 'H',
        },
        logoSize: {
            type: Number,
            default: 83,
        },
        margin: {
            type: Number,
            default: 1,
        },
        renderAs: {
            type: String,
            default: 'svg',
        },
        allowsave: {
            type: Boolean,
            default: false,
        },
    },
    data () {
        return {
            waiting: false
        }
    },
    computed: {
        config () {
            return this.$store.state.config;
        },
        colors () {
            const colors = {};
            const appColorsKeys = ['theme', 'background', 'foreground'];

            for (const key of appColorsKeys) {
                let m = document.querySelector(`meta[name="app-color-foreground"]`);
                if (m) {
                    colors[key] = m.getAttribute('content') || '';
                    continue;
                }
                colors[key] = this.config?.colors?.[key] || '';
            }

            return colors;

        }
    },
    methods: {
        downloadDataUrl (dataUrl) { // author: GPT-5.3-Codex
            const link = document.createElement('a');
            link.href = dataUrl;
            link.download = 'qr-code.png';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },
        svgToPngDataUrl (svgElement) { // author: GPT-5.3-Codex
            return new Promise((resolve, reject) => {
                const serializer = new XMLSerializer();
                const svgString = serializer.serializeToString(svgElement);
                const svgBlob = new Blob([svgString], { type: 'image/svg+xml;charset=utf-8' });
                const svgUrl = URL.createObjectURL(svgBlob);
                const image = new Image();

                image.onload = () => {
                    const canvas = document.createElement('canvas');
                    canvas.width = this.size;
                    canvas.height = this.size;
                    const ctx = canvas.getContext('2d');

                    if (!ctx) {
                        URL.revokeObjectURL(svgUrl);
                        reject(new Error('2D context is not available'));
                        return;
                    }

                    ctx.drawImage(image, 0, 0, this.size, this.size);
                    URL.revokeObjectURL(svgUrl);
                    resolve(canvas.toDataURL('image/png'));
                };

                image.onerror = () => {
                    URL.revokeObjectURL(svgUrl);
                    reject(new Error('Failed to load SVG image'));
                };

                image.src = svgUrl;
            });
        },
        async save () { // author: GPT-5.3-Codex
            this.waiting = true;

            try {
                const canvasElement = this.$el.querySelector('canvas');
                if (canvasElement) {
                    this.downloadDataUrl(canvasElement.toDataURL('image/png'));
                    return;
                }

                const svgElement = this.$el.querySelector('svg');
                if (svgElement) {
                    const dataUrl = await this.svgToPngDataUrl(svgElement);
                    this.downloadDataUrl(dataUrl);
                }
            } finally {
                this.waiting = false;
            }
        },
        click () { // отправляем клик на QR-код в родительский компонент
            this.$emit('click');
        }
    },
    template: /* vue-html */`
    <div class="qr" :class="{ 'qr--invalid': !valid }">
        <div
                class="qr-wrap"
                :style="{ '--qr-size': size + 'px', '--qr-logo-size': logoSize + 'px' }"
                @click.stop.prevent="click"
            >
            <QrCode
                    class="qr-code"
                    :key="value"
                    :value="value"
                    :size="size"
                    :level="level"
                    :margin="margin"
                    :render-as="renderAs"
                    :foreground="colors.foreground"
                />
            <img
                    v-if="logoUrl"
                    :src="logoUrl"
                    class="qr-logo"
                />
        </div>

        <button class="btn-accept btn--with-icon"
                v-if="valid && allowsave"
                :disabled="waiting"
                @click="save"
            ><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="h-5 w-5" aria-hidden="true">
                        <path d="M12 3v12"></path>
                        <path d="m7 10 5 5 5-5"></path>
                        <path d="M5 21h14"></path>
                    </svg><span>Сохранить QR</span></button>
    </div>
    `
};
